type ActivitySphereLabel = {
  code?: string | null;
  name: string;
};

export const formatActivitySphereLabel = ({
  code,
  name,
}: ActivitySphereLabel): string => (code ? `${code} ${name}` : name);

export const formatActivitySpheresList = (
  spheres: ActivitySphereLabel[],
  separator = ', '
): string => spheres.map(formatActivitySphereLabel).join(separator);
